import { render, staticRenderFns } from "./Pwa.vue?vue&type=template&id=0669470c&scoped=true&lang=pug"
import script from "./Pwa.vue?vue&type=script&lang=js"
export * from "./Pwa.vue?vue&type=script&lang=js"
import style0 from "./Pwa.vue?vue&type=style&index=0&id=0669470c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0669470c",
  null
  
)

export default component.exports